// Evenimente GA4 pentru funnel-ul de comanda.
// Se trimit DOAR daca GA4 e incarcat (adica dupa acordul de cookie-uri - vezi GoogleTracking.jsx).
// Fara date personale: niciun CUI, CNP, nume, email sau telefon.

const PENDING_KEY = 'ga_pending_purchase';
const SENT_PREFIX = 'ga_purchase_sent_';

const ITEM_NAMES = {
  basic: 'Certificat constatator',
  withHistory: 'Certificat constatator cu istoric'
};

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const buildItem = (certificateType, price, discount = 0) => ({
  item_id: certificateType,
  item_name: ITEM_NAMES[certificateType] || certificateType,
  price: round2(price),
  discount: round2(discount),
  quantity: 1
});

export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch (e) {
    // analiticele nu au voie sa afecteze site-ul
  }
};

// Salvat inainte de redirect-ul spre Stripe, citit pe pagina de succes
export const savePendingPurchase = (data) => {
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify(data));
  } catch (e) {}
};

// Trimite purchase o singura data per comanda, dupa ce GA4 s-a incarcat (max ~10s)
export const trackPurchaseWhenReady = (orderNumber) => {
  if (!orderNumber) return () => {};

  try {
    if (localStorage.getItem(SENT_PREFIX + orderNumber)) return () => {};
  } catch (e) {}

  let pending = null;
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    if (parsed && parsed.orderNumber === orderNumber) pending = parsed;
  } catch (e) {}

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (typeof window.gtag !== 'function') {
      if (tries >= 34) clearInterval(timer);
      return;
    }
    clearInterval(timer);

    const params = { transaction_id: orderNumber, currency: 'RON' };
    if (pending) {
      params.value = round2(pending.value);
      params.items = [buildItem(pending.certificateType, pending.value, pending.discount)];
      if (pending.coupon) params.coupon = pending.coupon;
    }
    // Profitul NU se trimite in GA (ar expune taxa ONRC); se calculeaza in admin -> Analitice, din setari.

    trackEvent('purchase', params);
    try {
      localStorage.setItem(SENT_PREFIX + orderNumber, '1');
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }, 300);

  return () => clearInterval(timer);
};
